import scrollbarSize from 'dom-helpers/scrollbarSize';

import '../scss/app.scss';
import 'normalize.css';
// Import cond-ui-kit globals (includes font definitions)
// Using relative path from artifacts directory (Vite root)
import '../../node_modules/cond-ui-kit/lib/compiled-css/globals.css';
// Override cond-ui-kit's global font to preserve app's current font
// Only the new navbar will use Open Sans via CSS variables
// Note: Import after cond-ui-kit so override takes precedence
import '../scss/foundations/cond-ui-kit-overrides.scss';



export function setupCss() {
	document.documentElement.style.setProperty('--scrollbar-size', `${scrollbarSize()}px`);
}
